import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useActionItemComposer, useNoteComposer, useUserSession } from '../../../../../../models/hooks/appStateHooks';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../../components/Tooltip';
import { AutomationSelectorModal } from '../../../../../components/automation/AutomationSelector';
import { ActionItemsIcon } from '../../../../../components/svgs/icons/ActionItemsIcon';
import { AutomationsIcon } from '../../../../../components/svgs/icons/AutomationsIcon';
import { NotesIcon } from '../../../../../components/svgs/icons/NotesIcon';
import { white } from '../../../../../styles/colors';
import { styleSheet } from './styles';

export const QuickActions = ({
	contact,
	onContentCreated,
}: {
	contact: Api.IContact;
	onContentCreated?: () => void;
}) => {
	const userSession = useUserSession();
	const actionItemComposer = useActionItemComposer();
	const noteComposer = useNoteComposer();

	const [automationPopoverOpen, setAutomationPopoverOpen] = React.useState(false);

	const addNote = () => {
		const note: Api.INote = Api.createRichContentWithReferencedEntities([contact]);
		const noteVm = new Api.NoteViewModel(userSession, note);

		// Show the note composer with completion callback
		noteComposer.show(noteVm, (richContent, composerResult) => {
			// Call the callback when note is successfully created or edited
			if (
				onContentCreated &&
				(composerResult === Api.RichContentComposerResult.Create ||
					composerResult === Api.RichContentComposerResult.Edit)
			) {
				onContentCreated();
			}
		});
	};
	const addActionItem = () => {
		const actionItemModel: Api.IActionItem = Api.createRichContentWithReferencedEntities([contact]);
		const actionItem = new Api.ActionItemViewModel(userSession, actionItemModel);

		// Show the action item composer with completion callback
		actionItemComposer.show(actionItem, (richContent, composerResult) => {
			// Call the callback when action item is successfully created or edited
			if (
				onContentCreated &&
				(composerResult === Api.RichContentComposerResult.Create ||
					composerResult === Api.RichContentComposerResult.Edit)
			) {
				onContentCreated();
			}
		});
	};
	const startAutomation = () => {
		setAutomationPopoverOpen(true);
	};

	const contactVm = React.useMemo(() => {
		return contact ? new Api.ContactViewModel(userSession, contact) : null;
	}, [contact, userSession]);

	return (
		<div className={css(styleSheet.quickActions)}>
			<Tooltip>
				<TooltipTrigger asChild>
					<a className={css(styleSheet.quickActionButton)} onClick={addNote}>
						<NotesIcon fillColor={white} />
					</a>
				</TooltipTrigger>
				<TooltipContent>Add Note</TooltipContent>
			</Tooltip>
			<Tooltip>
				<TooltipTrigger asChild>
					<a className={css(styleSheet.quickActionButton)} onClick={addActionItem}>
						<ActionItemsIcon fillColor={white} width={16} height={14} />
					</a>
				</TooltipTrigger>
				<TooltipContent>Add Action Item</TooltipContent>
			</Tooltip>
			<Tooltip>
				<TooltipTrigger asChild>
					<a className={css(styleSheet.quickActionButton)} onClick={startAutomation}>
						<AutomationsIcon fillColor={white} />
					</a>
				</TooltipTrigger>
				<TooltipContent>Start Automation</TooltipContent>
			</Tooltip>
			{!!contactVm && automationPopoverOpen ? (
				<AutomationSelectorModal
					contact={contactVm as unknown as Api.IContact}
					createAutomationForContact={true}
					closeModal={() => setAutomationPopoverOpen(false)}
				/>
			) : null}
		</div>
	);
};
